import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrivateService } from 'app/core/services/private.service';

@Component({
  selector: 'dialog-expense',
  templateUrl: './dialog-expense.component.html',
  styleUrls: ['./dialog-expense.component.scss']
})
export class DialogExpenseComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogExpenseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private privateService: PrivateService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  approveReimbursement(id: any){
    this.privateService.approveReimbursement(id).subscribe((res)=>{
      console.log(res);
      window.location.reload();
    })
  }

  declineReimbursement(id: any){
    this.privateService.declineReimbursement(id).subscribe((res)=>{
      console.log(res);
      window.location.reload();
    })
  }
}
